module.exports = __webpack_public_path__ + "img/laboratorio3_4-3_1536.231447b0.jpg";